import * as React from "react";
// import * as Scrollbars from 'react-custom-scrollbars';
// import * as FreeScrollbars from "react-free-scrollbar";
// import * as ReactSimpleBar from "simplebar-react";
import { AutoSizer, List } from "react-virtualized";
import * as Lodash from "lodash";
import VirtualLoader from "@tunnel-components/@sharded/@widgets/virtual-loader/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import * as shortid from "shortid";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    handleScroll,
    scrollTop,
    /*totalItemLength,*/ totalRowElements,
    cameraInactifs,
    heightView,
    widthView,
    rowHeight,
    itemPerRow,
    rowRenderer,
    classnames,
    id,
    onNextPage,
    arrayContent,
    onLastPage,
    onFirstPage,
    onPreviousPage,
    pageNumbers,
    visible,
    onSelectedPage,
    activePage,
    key,
  } = props;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <section className="content-wrapper">
      <section className={classnames} id={id}>
        {arrayContent && (
          <div style={{ height: heightView, width: widthView }} key={key}>
            <AutoSizer>
              {({ height, width }) => (
                /** scroll bar */

                <List
                  scrollTop={scrollTop}
                  height={height}
                  width={width}
                  onScroll={handleScroll}
                  // containerStyle={{ width: "auto", maxWidth: "100%" }}
                  // style = {{overflowX:"hidden", overflowY:"hidden"}}
                  rowHeight={rowHeight}
                  rowRenderer={rowRenderer}
                  overscanRowsCount={3}
                  rowCount={Math.ceil(totalRowElements / itemPerRow)}
                />
              )}
            </AutoSizer>
          </div>
        )}
        {!arrayContent && <VirtualLoader />}
      </section>
      {arrayContent && pageNumbers && !Lodash.isEmpty(pageNumbers) && (
        <Styled.paginationBtnVirtual style={{ marginBottom: "-4px" }}>
          {cameraInactifs /** vérifier si les caméras nécessitent des interventions */ && (
            <span
              style={{
                display: "inline-block",
                marginLeft: "35%",
                float: "left",
              }}
            >
              <Styled.spanPagination
                isVisible={true}
                style={{
                  color: "white",
                  borderRadius: "unset",
                  border: "none",
                  backgroundColor: "#ed5b56",
                  cursor: "default",
                  width: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  boxSizing: "border-box",
                }}
              >
                {i18next.t(
                  "attention des cameras necessitent une intervention"
                )}
              </Styled.spanPagination>
            </span>
          )}
          <span style={{ display: "inline-block" }}>
            <ul className="virtualListPages" style={{ listStyle: "none" }}>
              {activePage && !activePage[1] && (
                <Styled.spanPagination
                  isVisible={true}
                  onClick={onFirstPage}
                  title={i18next.t("page n°1")}
                >
                  {"<<"}
                </Styled.spanPagination>
              )}
              {activePage && !activePage[1] && (
                <Styled.spanPagination
                  isVisible={true}
                  onClick={onPreviousPage}
                  title={i18next.t("page precedente")}
                >
                  {"<"}
                </Styled.spanPagination>
              )}

              {pageNumbers.map((elem: any, index: number) => {
                return (
                  !Lodash.isUndefined(visible) &&
                  visible[index + 1] && (
                    <Styled.spanPagination
                      key={shortid.generate()}
                      isVisible={true}
                      title={elem}
                      active={activePage && activePage[index + 1]}
                      onClick={onSelectedPage(elem)}
                    >
                      <span>{elem}</span>
                    </Styled.spanPagination>
                  )
                );
              })}
              {activePage && !activePage[pageNumbers.length - 1] && (
                <Styled.spanPagination
                  isVisible={true}
                  onClick={onNextPage}
                  title={i18next.t("page suivante")}
                >
                  {">"}
                </Styled.spanPagination>
              )}
              {activePage && !activePage[pageNumbers.length - 1] && (
                <Styled.spanPagination
                  isVisible={true}
                  onClick={onLastPage}
                  title={i18next.t("derniere page")}
                >
                  {">>"}
                </Styled.spanPagination>
              )}
            </ul>
          </span>
        </Styled.paginationBtnVirtual>
      )}
    </section>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  handleScroll?: any;
  children?: any;
  heightView?: any;
  widthView?: any;
  rowHeight?: any;
  rowRenderer?: any;
  lengthOfList?: any;
  scrollTop?: any;
  id?: any;
  classnames?: any;
  onPreviousPage?: any;
  onNextPage?: any;
  pageNumbers?: any[];
  visible?: boolean[];
  onSelectedPage?: any;
  activePage?: boolean[];
  arrayContent?: any[];
  onLastPage?: any;
  onFirstPage?: any;
  totalItemLength?: any;
  cameraInactifs?: any;
  itemPerRow?: any;
  totalRowElements?: any;
  arrayContentIncident?: any;
  key?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/virtualized/pagination/component.tsx